import {
  getKnowledgeArticleLink,
} from '../../utils/knowledge/knowledgeArticles';
import { KnowledgeChannel } from '../../utils/knowledge/types';
import { KnowledgeLocale } from '../../utils/knowledge/knowledgeCopy';
import {
  KnowledgeContactButton,
  KnowledgeSidebar,
  KnowledgeSidebarItem,
  KnowledgeSidebarLink,
  KnowledgeSidebarList,
} from './KnowledgeCentre.styles';

interface KnowledgeHelpSidebarProps {
  channel: KnowledgeChannel;
  locale: KnowledgeLocale;
  topArticles: { urlName: string; title: string }[];
}

export const KnowledgeHelpSidebar = ({ channel, locale, topArticles }: KnowledgeHelpSidebarProps) => {
  const channelProp = { $channel: channel };

  return (
    <KnowledgeSidebar>
      <h2>Top Articles</h2>
      <KnowledgeSidebarList>
        {topArticles.map(({ urlName, title }) => (
          <KnowledgeSidebarItem key={urlName}>
            <KnowledgeSidebarLink href={getKnowledgeArticleLink(locale, channel, urlName)}>
              {title}
            </KnowledgeSidebarLink>
          </KnowledgeSidebarItem>
        ))}
      </KnowledgeSidebarList>
      <KnowledgeContactButton {...channelProp} href="#">
        Contact Support
      </KnowledgeContactButton>
    </KnowledgeSidebar>
  );
};
